<template>
  <div
    class="workshop-order"
    v-loading="dataLoading"
    :element-loading-text="$lange == 'en' ? '' : '正在同步SAP数据'"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-tabs v-model="activeName" type="border-card" v-loading="orderLoading">
      <el-tab-pane
        :label="$lange == 'en' ? 'Order operation management' : '订单工序管理'"
        name="order"
      >
        <div class="body">
          <div class="top flex-between">
            <el-select
              size="mini"
              v-model="paramsData.status"
              placeholder="请选择订单状态"
              clearable
            >
              <el-option
                :label="$lange == 'en' ? 'All' : '全部'"
                value=""
              ></el-option>
              <el-option
                :label="$lange == 'en' ? 'Unrelated' : '未关联'"
                :value="0"
              ></el-option>
              <el-option
                :label="$lange == 'en' ? 'Associated ' : '已关联'"
                :value="1"
              ></el-option>
            </el-select>
            <el-input
              size="mini"
              :placeholder="
                $lange == 'en' ? 'Please enter order number' : '请输入订单编号'
              "
              v-model="paramsData.numbering"
            ></el-input>
            <el-button type="primary" size="mini" @click="doSearch">{{
              $lange == "en" ? "Search" : "搜索"
            }}</el-button>
            <el-button size="mini" type="primary" @click="SynchronousSAP">{{
              $lange == "en" ? "Synchronous SAP" : "同步SAP单元工序"
            }}</el-button>
          </div>
          <div class="bottom flex-between">
            <div class="lists left">
              <div class="title">
                {{ $lange == "en" ? "Order list" : "订单列表" }}
              </div>
              <div class="list-box" style="height: 440px">
                <div class="list flex-between list-title">
                  <span style="width: 25px"></span>
                  <span style="width: 120px">{{
                    $lange == "en" ? "Order number" : "订单编号"
                  }}</span>
                  <span>{{ $lange == "en" ? "Status" : "状态" }}</span>
                </div>
                <el-radio-group v-model="activeIndex">
                  <div
                    class="list flex-between"
                    v-for="(item, index) in orderData"
                  >
                    <span style="width: 25px">
                      <el-radio :label="index"></el-radio>
                    </span>
                    <span style="width: 120px">{{ item.numbering }}</span>
                    <span :class="item.status === 1 ? 'success' : ''">
                      <template v-if="$lange == 'en'">
                        {{ ["Unrelated", "Associated"][item.status] }}
                      </template>
                      <template v-else>
                        {{ ["未关联", "已关联"][item.status] }}
                      </template>
                    </span>
                  </div>
                </el-radio-group>
              </div>
              <div class="page-box">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="pageNo"
                  size="mini"
                  :page-size="pageSize"
                  layout="prev, pager, next"
                  :total="pageSizeTotal"
                >
                </el-pagination>
              </div>
            </div>
            <div class="lists right">
              <div class="title">
                {{
                  $lange == "en"
                    ? "Order-working Process list"
                    : "订单-工序列表"
                }}
              </div>
              <div class="list-box">
                <div class="list flex-between list-title">
                  <span>{{
                    $lange == "en" ? "Process content" : "工序内容"
                  }}</span>
                   <span>{{
                    $lange == "en" ? "Process Type" : "工序类型"
                  }}</span>
                  <span>{{
                    $lange == "en" ? "Estimated working hours" : "预计工时"
                  }}</span>
                  <span>{{
                    $lange == "en" ? "estimated output" : "预计产量"
                  }}</span>
                </div>
                <div class="list flex-between" v-if="processList == ''">
                  <span>{{ $lange == "en" ? "No Data" : "暂无数据" }}</span>
                </div>
                <div
                  class="list flex-between"
                  v-for="(item, index) in processList"
                >
                  <span>{{ item.content }}</span>
                  <span v-if="item.type=='FC104'">电气类</span>
                  <span v-if="item.type=='FC101'">机械类</span>
                  <span v-if="item.type=='FC108'">调试类</span>

                  <span>{{ item.estimatedWorkingHours }}</span>
                  <span>{{ item.expectedProduction }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "WorkshopOrder",
  watch: {
    activeIndex: {
      handler() {
        console.log(this.activeIndex,"this.activeIndex")
        if(this.activeIndex!==""){
          this.processList = this.orderData[this.activeIndex].workshopProcessList;
        }
      },
      deep: true,
    },
    paramsData2: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  data() {
    return {
      dataLoading: false,
      orderLoading: true,
      pageNo: 1,
      pageSize: 10,
      pageSizeTotal: 1,
      activeName: "order",
      activeIndex: "",
      orderData: [],
      processList: [],
      paramsData: {
        status: "",
        numbering: "",
      },
      paramsData2: {
        status: "",
        numbering: "",
      },
    };
  },
  methods: {
    doSearch() {
      this.paramsData2 = { ...this.paramsData };
      this.activeIndex=""
      this.processList =[]
    },
    SynchronousSAP() {
      let text =
        this.$lange == "en" ? "Synchronous SAP" : "当前操作为同步SAP数据";
      let title = this.$lange == "en" ? "Tips" : "提示";
      this.$confirm(text, title, {
        confirmButtonText: this.$lange == "en" ? "Yes" : "确定",
        cancelButtonText: this.$lange == "en" ? "No" : "取消",
        type: "warning",
      }).then((res) => {
        this.dataLoading = true;
        this.ccRequest
          .do("admin/fsb/sap/customJco/orderSynchronize", {}, "GET")
          .then((res) => {
            this.$message({
              type: "success",
              message: "同步成功",
            });
            this.getData();
          })
          .catch((res) => {
            this.dataLoading = false;
            this.$message({
              type: "danger",
              message: "同步失败, 请重试",
            });
          });
      });
    },
    handleSizeChange() {},
    handleCurrentChange(res) {
      this.activeIndex = "";
      this.pageNo = res;
        this.activeIndex=""
      this.processList =[]
      this.getData();
    },
    getData() {
      this.orderLoading = true;
      let data = this.paramsData;
      data.pageSize = this.pageSize;
      data.pageNo = this.pageNo;
      this.ccRequest
        .do("admin/fsb/workshop/order/query", data, "GET")
        .then((res) => {
          this.orderData = res.rows;
          this.pageSizeTotal = res.total;
          this.dataLoading = false;
          this.orderLoading = false;
        })
        .catch((res) => {
          this.dataLoading = false;
          this.orderLoading = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="scss">
.list .el-radio__label {
  opacity: 0 !important;
}
</style>
<style scoped lang="scss">
.workshop-order {
  min-height: 100vh;
  box-sizing: border-box;
  .body {
    height: 100vh;
    .top {
      padding: 20px;
      justify-content: flex-start;
      > * {
        max-width: 200px;
        margin-right: 20px;
      }
    }
    .bottom {
      align-items: flex-start;
      padding: 20px 20px 0px 20px;
      border-top: 5px solid #f3f3f4;
      .lists {
        height: 70vh;
        padding: 0 20px;
        .title {
          color: #6f6f6f;
          padding: 15px;
          border-bottom: 2px solid #c4c4c4;
        }
        .list-box {
          margin-top: 15px;
          .list {
            justify-content: flex-start;
            padding: 10px;
            color: #c2c2bf;
            font-size: 12px;
            border-bottom: 1px dotted #b1b1b1;
            > * {
              margin-right: 10px;
              &:last-child {
                margin-right: 0;
                flex: 1;
              }
            }
            &.list-title {
              font-size: 14px;
              border-bottom: none;
              background: #f3f3f4;
              color: #6f6f6f;
            }
          }
        }
        &.left {
          width: 360px;
          // overflow: auto;
          position: relative;
          .list {
            width: 340px;
          position: relative;

          }
          .page-box {
            // position: absolute;
            // bottom: 20px;
            // left: calc(50% - 10px);
            // transform: translateX(-50%);
          }
        }
        &.right {
          flex: 1;
          overflow: auto;
          border-left: 5px solid #f3f3f4;
          .list-box {
            .list {
              > * {
                width: 120px;
                text-align: center;
                &:last-child {
                  margin-right: 0;
                  flex: none;
                }
              }
            }
          }
        }
      }
    }
  }
  .success {
    color: #67c23a;
  }
}
</style>
